<div class="bg-gray-100 font-sans antialiased min-h-screen">
    <!-- Header Section -->
    <div class="flex flex-col md:flex-row items-center justify-between p-4 md:px-8 md:py-6">
        <!-- Logo -->
        <div class="mb-4 md:mb-0 md:ml-4">
            <img alt="Logo" class="h-20 md:h-24 w-auto" src="assets/companyLogo.png"/>
        </div>

        <!-- Search and Icons -->
        <div class="w-1/2 md:w-auto   md:flex-row  md:space-y-0 md:space-x-6 lg:mr-24">
            <!-- Search Bar -->
            <!-- <div class="w-full md:w-64 flex items-center bg-white rounded-full px-4 py-2 shadow-sm">
                <input class="flex-1 bg-transparent outline-none text-sm"
                       placeholder="Try Searching"
                       type="text"/>
                <i class="fas fa-search text-gray-400 ml-2"></i>
            </div> -->

            <!-- Icons -->
            <div class="flex  space-x-6 md:space-x-8">
                <i class="fas fa-bell text-purple-700 relative text-lg">
                    <span class="absolute top-0 right-0 inline-block w-2 h-2 bg-red-600 rounded-full"></span>
                </i>
                <i class="fas fa-envelope text-gray-400 text-lg"></i>
                <i class="fas fa-user text-gray-400 text-lg"></i>
                <i class="fas fa-sign-out-alt text-gray-400 text-lg cursor-pointer" 
                   (click)="onLogoutClick()"></i>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="flex flex-col md:flex-row px-4 pb-4">
        <!-- Sidebar -->
        <div class="w-full md:w-64 bg-white rounded-lg shadow-md mb-4 md:mb-0 md:mr-6">
            <nav class="p-4 space-y-2">
                <a class="flex items-center p-3 pl-10 rounded-lg hover:bg-purple-50  text-gray-600 cursor-pointer"
                   (click)="onDashboarClick()">
                    <i class="fas fa-home mr-3"></i>
                    <span class="text-sm font-medium">Dashboard</span>
                    <!-- <i class="fas fa-caret-down ml-auto"></i> -->
                </a>
                <a class="flex items-center p-3 rounded-lg bg-purple-50 hover:bg-purple-50 text-purple-600 cursor-pointer"
                   (click)="onclinicClick()">
                    <i class="fas fa-clinic-medical mr-3"></i>
                    <span class="text-sm font-medium">Clinics</span>
                    <!-- <i class="fas fa-caret-down ml-auto"></i> -->
                </a>
            </nav>
        </div>

        <!-- Content Area -->
        <div class="flex-1">
            <h1 class="text-xl md:text-2xl font-bold mb-6 mt-4">Clinic Dashboard</h1>
            
            <!-- Clinic Selector -->
            <div class="mb-6">
                <label class="block mb-2 text-sm md:text-base text-gray-700">Select Clinic</label>
                <select 
                    [(ngModel)]="selectedClinic" 
                    (change)="fetchClinicStats()"
                    class="w-full md:w-64 p-2 md:p-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm md:text-base"
                >
                    <option *ngFor="let clinic of clinics" [value]="clinic">
                        {{ clinic }}
                    </option>
                </select>
            </div>

            <!-- Stats Cards -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <div class="flex justify-between items-center">
                        <div>
                            <p class="text-xs md:text-sm text-gray-500">Total Tests</p>
                            <p class="text-2xl md:text-3xl font-bold text-purple-600">{{ clinicStats?.totalTests }}</p>
                        </div>
                        <div class="bg-purple-100 p-2 rounded-full">
                            <i class="fas fa-file-alt text-purple-600"></i>
                        </div>
                    </div>
                </div>

                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <div class="flex justify-between items-center">
                        <div>
                            <p class="text-xs md:text-sm text-gray-500">Control Tests</p>
                            <p class="text-2xl md:text-3xl font-bold text-purple-600">{{ clinicStats?.controlTests }}</p>
                        </div>
                        <div class="bg-purple-100 p-2 rounded-full">
                            <i class="fas fa-check-circle text-purple-600"></i>
                        </div>
                    </div>
                </div>

                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <div class="flex justify-between items-center">
                        <div>
                            <p class="text-xs md:text-sm text-gray-500">Implant Tests</p>
                            <p class="text-2xl md:text-3xl font-bold text-purple-600">{{ clinicStats?.implantTests }}</p>
                        </div>
                        <div class="bg-purple-100 p-2 rounded-full">
                            <i class="fas fa-flask text-purple-600"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Charts Section -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <h2 class="text-lg md:text-xl font-semibold text-purple-600 mb-4">Weekly Test Summary</h2>
                    <div class="w-full h-64">
                        <canvas #weeklyChart></canvas>
                    </div>
                </div>

                <div class="bg-white p-4 rounded-lg shadow-sm">
                    <h2 class="text-lg md:text-xl font-semibold text-purple-600 mb-4">Test Type Distribution</h2>
                    <div class="w-full h-64">
                        <canvas #distributionChart></canvas>
                    </div>
                </div>
            </div>

            <!-- Reports Section -->
            <div class="bg-white rounded-lg shadow-sm p-4">
                <div class="flex flex-col md:flex-row justify-between items-center mb-6 space-y-4 md:space-y-0">
                    <h2 class="text-lg md:text-xl font-semibold">Reports</h2>
                   
                </div>

                <!-- Table -->
                <div class="overflow-x-auto">
                    <table class="w-full min-w-[800px] md:min-w-0">
                        <thead class="bg-purple-50">
                            <tr>
                                <th class="text-xs md:text-sm p-2 text-left">#</th>
                                <th class="text-xs md:text-sm p-2 text-left">Start Time</th>
                                <th class="text-xs md:text-sm p-2 text-left">End Time</th>
                                <th class="text-xs md:text-sm p-2 text-left">Well Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Serial Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Result</th>
                                <th class="text-xs md:text-sm p-2 text-left">BI Type</th>
                                <th class="text-xs md:text-sm p-2 text-left">BI Lot Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Sterilizer Model</th>
                                <th class="text-xs md:text-sm p-2 text-left">Load Number</th>
                                <th class="text-xs md:text-sm p-2 text-left">Team Member</th>
                                <th class="text-xs md:text-sm p-2 text-left">Cycle</th>
                                <th class="text-xs md:text-sm p-2 text-left">Chemical Integrator</th>
                                <th class="text-xs md:text-sm p-2 text-left">Control</th>
                                <th class="text-xs md:text-sm p-2 text-left">Implant</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let record of clinicRecords; let i = index" 
                                class="border-t hover:bg-gray-50">
                                <td class="text-xs md:text-sm p-2 whitespace-nowrap">{{ i+1 }}</td>
                                <td class="text-xs md:text-sm p-2 whitespace-nowrap">
                                    {{ record.startTime | date:'dd-MM-yy HH:mm' }}
                                </td>
                                <td class="text-xs md:text-sm p-2 whitespace-nowrap">
                                    {{ record.endTime | date:'dd-MM-yy HH:mm' }}
                                </td>
                                <td class="text-xs md:text-sm p-2">{{ record.wellNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.serialNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.result }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.biType }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.biLotNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.sterilizerModels }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.loadNumber }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.technicianNames }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.cycleCount }}</td>
                                <td class="text-xs md:text-sm p-2">{{ record.chemicalIntegrators }}</td>
                                <td class="text-xs md:text-sm p-2">
                                    <button class="text-purple-600 hover:text-purple-800 text-xs md:text-sm px-2 py-1 border rounded disabled:opacity-50"
                                            [disabled]="!record.isControlTest">
                                        Control
                                    </button>
                                </td>
                                <td class="text-xs md:text-sm p-2">
                                    <button class="text-purple-600 hover:text-purple-800 text-xs md:text-sm px-2 py-1 border rounded disabled:opacity-50"
                                            [disabled]="!record.isImplant">
                                        Implant
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Pagination -->
                <div class="flex flex-col md:flex-row justify-between items-center mt-6 space-y-4 md:space-y-0">
                    <span class="text-xs md:text-sm text-gray-600">
                        Showing {{ clinicRecords.length }} of {{ clinicStats?.totalTests }} records
                    </span>
                    <div class="flex space-x-2">
                        <button class="px-3 py-1 text-xs md:text-sm bg-purple-500 text-white rounded hover:bg-purple-600 disabled:opacity-50"
                                (click)="changePage(currentPage - 1)" 
                                [disabled]="currentPage === 0">
                            Previous
                        </button>
                        <button class="px-3 py-1 text-xs md:text-sm bg-purple-500 text-white rounded hover:bg-purple-600 disabled:opacity-50"
                                (click)="changePage(currentPage + 1)" 
                                [disabled]="currentPage === totalPages+1">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>